import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Router from './routes/Router'
import Header from '@repo/ui/header'
import Footer from '@repo/ui/footer'
import { DataProvider } from './hooks/useDataProvider'

import './App.css'
import 'react-toastify/dist/ReactToastify.css'

import useStorageCommon from './store/useStorageCommon'

function App() {
  const source = useStorageCommon((state) => state.source)

  return (
    <div className="min-h-screen flex flex-col">
      <Header showHeader={source !== 'app'} />
      <BrowserRouter>
        <DataProvider>
          <Router />
        </DataProvider>
      </BrowserRouter>
      <Footer showFooter={source !== 'app'} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  )
}

export default App

